import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractStage } from '../../../models/Entities/Contracts/ContractStage';

export default function ContractStagesByAddendumReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    case 'CONTRACTSTAGE_ADD_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.newContractStage.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.newContractStage.contractAddendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isSaving: true,
            isSavedSuccessfully: false,
            failOnSaving: false,
            error: undefined,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.newContractStage.contractAddendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_GET_ALL_BY_ADDENDUMID_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractStages: true,
            isGettingContractStagesSuccess: false,
            FailGettingContractStages: false,
            ErrorGettingContractStages: undefined
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_GET_ALL_BY_ADDENDUMID_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractStages: false,
            isGettingContractStagesSuccess: true,
            FailGettingContractStages: false,
            ErrorGettingContractStages: undefined,
            stages: a.contractStages as ContractStage[]
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_GET_ALL_BY_ADDENDUMID_FAIL_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractStages: false,
            isGettingContractStagesSuccess: false,
            FailGettingContractStages: true,
            ErrorGettingContractStages: a.error
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
        error: a.error
      };
    }
    case 'CONTRACTSTAGE_ADD_RANGE_FINALIZED_ACTION': {
      const UpdatedContracts = (currentState.list || []).map((contract: Contract) => {
        const UpdatedAddendums = (contract.addendums || []).map((addendum: ContractAddendum) => {
          if (!addendum.isSaving) return addendum;

          return {
            ...addendum,
            isSaving: false,
            isSavedSuccessfully: true,
            failOnSaving: false,
            error: undefined,
          } as ContractAddendum;
        });

        return {
          ...contract,
          addendums: UpdatedAddendums,
        } as Contract;
      });

      return {
        ...currentState,
        list: UpdatedContracts,
      };
    }
    case 'CONTRACTSTAGE_ADD_FAIL_ACTION': {
      const UpdatedContracts = (currentState.list || []).map((contract: Contract) => {
        const UpdatedAddendums = (contract.addendums || []).map((addendum: ContractAddendum) => {
          if (!addendum.isSaving) return addendum;

          return {
            ...addendum,
            isSaving: false,
            isSavedSuccessfully: false,
            failOnSaving: true,
            error: a.error,
          } as ContractAddendum;
        });

        return {
          ...contract,
          addendums: UpdatedAddendums,
        } as Contract;
      });

      return {
        ...currentState,
        list: UpdatedContracts,
        error: a.error,
      };
    }
    default:
      return currentState;
  }
}
